//helper
// import Account from '@/helper/AccountHelper.js';
import ConfigManager from "@/config/ConfigManager.js";
import CacheHelper from "@/helper/CacheHelper.js";
import Locale from '@/helper/locale/Locale.js';
// import Util from '@/helper/Utility.js';
import { CampaignType } from "@/helper/StaticValue.js";
//core
// import { CallbackEvent } from '@/core/Utility/CallbackEvent.js';
//config
import {
    RedeemConfigBuilder,
    RedeemShippingAddressConfigBuilder,
    RedeemOtherConfigBuilder,
    RedeemInfoConfigBuilder
} from '@/core/Redeem/config/RedeemConfigBuilder.js';
//model
import { AddCartModel } from '@/core/Cart/model/CartModel.js';
import { WebInterfaceController } from './WebInterfaceController';
//service
import BzbsCart from '@/core/Cart/service/BzbsCart.js';
import BzbsRedeem from '@/core/Redeem/service/BzbsRedeem.js';
import { DrawDeliveryModel } from '@/core/Redeem/model/DrawDeliveryModel.js';
import { SerialModel } from '@/core/Redeem/model/SerialModel.js';
import BzbsHistory from '@/core/History/service/BzbsHistory.js';
import BzbsAddressList from "@/core/Address/service/BzbsAddressList.js";
// import { ModalController } from '../../../components/Modal/ModalController';

/**
 * event
 * @method onRedeemSuccess
 * @method onErrorApi
 * @method onRedirect
 */
export function RedeemController () {
    this.lbl = Locale.getLbl();
    this.localeCode = Locale.getLocaleCode();
    this.cacheHelper = new CacheHelper();

    this.campaign = {};
    this.selectedCampaignId = null;
    this.selectedQuantity = null;

    this.redeemConfigBuilder = new RedeemConfigBuilder();
    this.modal = null;

    // this.cbRedeemSuccess = new CallbackEvent();
    // this.cbRedirect = new CallbackEvent();
    // this.cbApiError = new CallbackEvent();

    //#region initial
    /**
     * @param {CampaignModel} campaign /core/Campaign/model/CampaignModel.js
     * @param {modal} modal /components/Modal/ModalController.js
     */
    this.initial = (campaign, modal) => {
        this.campaign = campaign;
        this.modal = modal;
    };
    /**
     * @param {CampaignModel} campaign /core/Campaign/model/CampaignModel.js
     */
    this.reinitial = (campaign) => {
        this.lbl = Locale.getLbl();
        this.campaign = campaign;
    }
    //#endregion initial

    //#region redeem
    /**
     * Click ปุ่ม Redeem แล้วจะเรียกที่นี่
     *      - show popup confirm
     * @param {Number} selectedCampaignId campaign id
     * @param {Number} selectedQuantity quanty
     */
    this.clickRedeem = (selectedCampaignId, selectedQuantity) => {
        if (!this.onClickRedeem()) {
            return;
        }

        this.selectedCampaignId = selectedCampaignId;
        this.selectedQuantity = selectedQuantity;
        if (this.selectedQuantity > 1) {
            this.selectedQuantity = this.selectedQuantity * this.campaign.pointPerUnit;
        }
        if (this.campaign.type == CampaignType.VerifyCode  || this.campaign.type == CampaignType.Deal) {
            this.modal.verifyCodeModal
                            .clearModal()
                            .setCampaign(this.campaign)
                            .show()
            this.modal.verifyCodeModal.onClickOk((code) => {
                if (this.campaign.type == CampaignType.VerifyCode) {
                    let verifyCode = new RedeemOtherConfigBuilder();
                    verifyCode.setVerifyCode(code);
                    this.redeemConfigBuilder.redeemOtherConfigBuilder = verifyCode;
                } else {
                    let info3 = new RedeemInfoConfigBuilder();
                    info3.setInfo3(code);
                    this.redeemConfigBuilder.redeemInfoConfigBuilder = info3;
                }

                if (!this.onConfirmRedeem()) {
                    return;
                }
                this.confirmRedeem();
            });
        } else {
            this.modal.confirmRedeemModal
                            .clearModal()
                            .setCampaign(this.campaign)
                            .show()

            this.modal.confirmRedeemModal.onShow(() =>{
                this.onShowRedeem();
            });

            this.modal.confirmRedeemModal.onClickOk(() => {
                // event confirm redeem
                if (!this.onConfirmRedeem()) {
                    return;
                }

                this.confirmRedeem();
            });

            this.modal.confirmRedeemModal.onClickCancel(() => {

                // event cancel redeem
                this.onCancelRedeem();
            });
        }

    };

    /**
     * * Click popup Confirm Redeem แล้วจะเรียกที่นี่
     */
    this.confirmRedeem = () => {
        //% Open web Campaign Type 8
        if (this.isCampaignTypeInterFace()) {
            if (!this.onOpenInterface()) {
                return;
            }

            this.openWebInterface();
        }

        //% Open web Survey
        else if (this.isCampaignTypeSurvey()) {
            var surveyUrl = this.campaign.website;
            this.onOpenInterface({ type: 'web', link: surveyUrl });
        }

        //% ไม่รู้คืออะไร เขียนไว้กันลืม
        else if (this.isCampaignTypeApi()) {
            this.onOpenInterface();
        }

        //% Add item to cart
        else if (this.isCampaignTypeBuy()) {
            if (!this.onAddToCart()) {
                return;
            }
            this.addToCart();
        }

        //% Open modal shipping
        else if (this.campaign.delivered) {
            if (!this.onOpenShipping()) {
                return;
            }
            console.log('in delivred');

            this.openDeliveryCampaign();
        }

        //% Normal Redeem
        else {
            if (!this.onRedeem()) {
                return;
            }
            this.redeem();
        }
    };

    /**
     * * Redeem delivery open shipping address
     */
    this.openDeliveryCampaign = function() {
        if (ConfigManager.getAddressType() == "profile") {
            this.shippingAddress();
        } else if (ConfigManager.getAddressType() == "addressList") {
            this.modal.listAddressModal
                    .setNotShowModalAfterUpdate()
                    .show();
            this.modal.listAddressModal.onUpdateSuccess((address) => {
                if (!this.onSaveShipping()) {
                    return;
                }
                let addressBuilder = new RedeemShippingAddressConfigBuilder();
                addressBuilder.setAddressFromDeliveryAddressModel(address);
                this.redeemConfigBuilder.redeemShippingAddressConfigBuilder = addressBuilder;
                this.redeem();
            });
        } else {
            console.log("มึงเขียนคอนฟิก Shipping Address ผิด");
        }
    };

    /**
     * * Call api Redeem
     */
    this.redeem = () => {
        var params = this.redeemConfigBuilder.getRedeemParams();
        this.modal.loadingModal.show();
        BzbsRedeem.apiRedeemCampaign(this.selectedCampaignId, params, this.selectedQuantity).subscribe({
            next: (campaign) => {
                this.modal.loadingModal.hide();
                this.campaign.updateAfterRedeem(campaign);

                this.initialSerial();
                this.onRedeemSuccess(campaign);
            },
            error: (err) => {
                this.modal.loadingModal.hide();
                this.onRedeemError(err);
                if ((err.code == 404 && err.id == 404)
                    || (err.code == 409 && err.id == 409)
                    || (err.code == 409 && err.id == 2021)) {
                    this.modal.verifyCodeModal
                            .clearModal()
                            .setCampaign(this.campaign)
                            .setError(err)
                            .show()
                    this.modal.verifyCodeModal.onClickOk((code) => {
                        if (params.info3) {
                            let info3 = new RedeemInfoConfigBuilder();
                            info3.setInfo3(code);
                            this.redeemConfigBuilder.redeemInfoConfigBuilder = info3;
                        } else {
                            let verifyCode = new RedeemOtherConfigBuilder();
                            verifyCode.setVerifyCode(code);
                            this.redeemConfigBuilder.redeemOtherConfigBuilder = verifyCode;
                        }
                        if (!this.onConfirmRedeem()) {
                            return;
                        }
                        this.confirmRedeem();
                    });
                }
            },
        })
    };
    //#endregion redeem

    //#region interface redeem open web
    this.openWebInterface = function () {
        let webInterface = new WebInterfaceController(this.campaign);
        webInterface.openInterface();


        //TODO: Setup link
        // var webUrl = this.campaign.website;
        // var isShowHeader = 'false';
        // var theme = ConfigManager.getAppName();
        // var suffledToken = Account.getTokenShuffle();

        // if (webUrl.indexOf('/Topup/InterfaceLanding') >= 0) {
        //     this.cacheHelper.setCache('isfromlanding', { page: 'interface' });
        // } else if (webUrl.indexOf('wondd') >= 0) {
        //     this.cacheHelper.setCache('isfromlanding', { page: 'wodd' });
        // } else {
        //     this.cacheHelper.setCache('isfromlanding', { page: 'other' });
        // }

        // webUrl += '&token=' + suffledToken
        //         + '&locale=' + this.localeCode
        //         + '&header=' + isShowHeader
        //         + '&theme=' + theme
        //     + '&return_url=' + encodeURIComponent(window.location.href);

        // // support history truemoney
        // if (webUrl.indexOf('wondd/truemoney') == -1 && webUrl.indexOf('truemoney') >= 0) {
        //     webUrl += '&history_url=' + encodeURIComponent(window.location.href + '/history');
        // }

        // window.location.href = webUrl;
    };
    //#endregion interface redeem open web

    //#region buy
    this.addToCart = () => {
        var cartItem = new AddCartModel();
        var cartParams = cartItem.addItem(this.selectedCampaignId, this.selectedQuantity)
                            .getParams();

        BzbsCart.apiAddToCart(cartParams).subscribe({
            next: (data) => {
                this.onAddToCartSuccess();
                console.log(data);
            },
            error: (err) => {
                this.onAddToCartError(err);
            },
        });
    };
    //#endregion buy

    //#region serial
    this.initialSerial = () => {
        if (this.campaign.delivered || this.campaign.type == CampaignType.Draw) {
            var drawDelivery = new DrawDeliveryModel();
            console.log(drawDelivery);
            drawDelivery.setModelFromDataModel(this.campaign);
            this.modal.drawDeliveryModal
                .setTitle(this.lbl.serial.delivery.title)
                .setDrawDelivery(drawDelivery)
                .setBtnOk(this.lbl.serial.delivery.btn_coupon)
                .show();
            this.modal.drawDeliveryModal.onClose(() => {
                this.onCloseDelivery();
                window.location.href = '/home';
            })
            this.modal.drawDeliveryModal.onClickOk(() => {
                this.onViewDelivery();
                window.location.href = '/history';
            })
        } else {
            var serial = new SerialModel();
            serial.setModelFromDataModel(this.campaign);
            if (this.campaign.type == CampaignType.VerifyCode) {
                this.modal.serialModal
                    .setSerial(serial)
                    .setIsStaff(false)
                    .setIsShowStaff(true)
                    .show();
            } else if (this.isTypeFreeMarkUsed() || this.isTypeDealMarkUsed()) {
                this.modal.serialModal
                    .setSerial(serial)
                    .setIsStaff(false)
                    .setIsShowStaff(true)
                    .show();
            } else {
                this.modal.serialModal
                    .setSerial(serial)
                    .show();
            }

            this.modal.serialModal.onCloseModal(() => {
                window.location.href = '/home';
            });
            this.modal.serialModal.onClickCoupon(() => {
                window.location.href = '/history';
            });
            this.modal.serialModal.onClickDetail((data) => {
                console.log(data);
                window.location.href = '/campaign/' + this.campaign.id;
            });
            this.modal.serialModal.onSerialExpire(data => {
                console.log(data);
            });
            this.modal.serialModal.onClickForStaff(data => {
                if (data) {
                    BzbsHistory.apiRedeemArrange(data.redeemKey).subscribe({
                        next: (res) => {
                            console.log(res);
                        },
                        error: (err) => {
                            console.log('err',err);
                        },
                    })
                }
            });
        }
    };
    this.shippingAddress = (address) => {
        if (address) {
            this.modal.shippingAddressModal
                .clearModal()
                .setTitle(this.lbl.shipping.headline)
                .setAddress(address)
                .setEditAddress(true)
                .setBtnOk(this.lbl.shipping.confirm_btn)
                .show();
        } else {
            this.modal.shippingAddressModal
                .clearModal()
                .setTitle(this.lbl.shipping.headline)
                .setBtnOk(this.lbl.shipping.confirm_btn)
                .show();
        }
        this.modal.shippingAddressModal.onSaveAddress(data => {
            if (!this.onSaveShipping()) {
                return;
            }
            console.log(data);
            this.confirmShippingDelivery(data.builder, data.params);
        });
    }
    this.confirmShippingDelivery = (address, params) => {
        this.redeemConfigBuilder.redeemShippingAddressConfigBuilder = address;
            this.modal.confirmModal
                .clearModal()
                .setTitle(this.lbl.shipping.modal_confirm.title)
                .setMsg(this.lbl.shipping.modal_confirm.msg)
                .setBtnOk(this.lbl.shipping.confirm_btn)
                .setBtnCancel(this.lbl.shipping.modal_confirm.btn_edit)
                .show();
            this.modal.confirmModal.onClickCancel(() => {
                this.onCancelShipping();

                this.modal.shippingAddressModal
                    .clearModal()
                    .setAddress(address)
                    .setEditAddress(true)
                    .setTitle(this.lbl.shipping.headline)
                    .setBtnOk(this.lbl.shipping.confirm_btn)
                    .show();

                this.shippingAddress(address);
            })
            this.modal.confirmModal.onClickOk(() => {
                this.onConfirmShipping();
                if (params) {
                    BzbsAddressList.apiUpdateAddress(params).subscribe({
                        next: (res) => {
                            if (res) {
                                this.redeem();
                            }
                        },
                        error: (err) => {
                            console.log('err',err);
                        },
                    })
                } else {
                    this.redeem();
                }
            })
    }
    //#endregion serial

    //#region event
    this.onShowRedeem = () => true;
    this.onClickRedeem = () => true;
    this.onConfirmRedeem = () => true;
    this.onCancelRedeem = () => true;
    this.onOpenInterface = () => true;
    this.onOpenShipping = () => true;
    this.onSaveShipping = () => true;
    this.onConfirmShipping = () => true;
    this.onCancelShipping = () => true;
    this.onRedeem = () => true;
    this.onRedeemSuccess = () => true;
    this.onRedeemError = () => true;
    this.onAddToCart = () => true;
    this.onAddToCartSuccess = () => true;
    this.onAddToCartError = () => true;
    this.onCloseDelivery = () => true;
    this.onViewDelivery = () => true;
    //#endregion event

    //#region private function
    this.isCampaignTypeInterFace = function() {
        return (this.campaign.type == CampaignType.Interface)
            && (this.campaign.interfaceDisplay == 'web');
    };
    this.isCampaignTypeSurvey = function() {
        return (this.campaign.type == CampaignType.Interface)
            && (this.campaign.interfaceDisplay == 'survey' || this.campaign.interfaceDisplay == 'surveyapprove');
    };
    this.isCampaignTypeApi = function() {
        return (this.campaign.type == CampaignType.Interface)
            && (this.campaign.interfaceDisplay == 'api');
    };
    this.isCampaignTypeBuy = function() {
        return (this.campaign.type == CampaignType.Buy);
    };
    this.isTypeFreeMarkUsed = function(){
        return (this.campaign.type === CampaignType.Free && this.campaign.privilegeMessage && this.campaign.privilegeMessage.toLowerCase() == 'mark use');
    };
    this.isTypeDealMarkUsed = function(){
        return (this.campaign.type === CampaignType.Deal && this.campaign.privilegeMessage && this.campaign.privilegeMessage.toLowerCase() == 'mark use');
    };
    //#endregion private function
}
